import {
  Directive,
  HostBinding,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NkMatSidenavHelperService } from '../services/app-services/sidenav.service';
import { take } from 'rxjs';

@Directive({
  selector: '[appNkMatSidenavHelper]',
  standalone: true
})
export class NkMatSidenavHelperDirective implements OnInit {
  @HostBinding('class.mat-is-locked-open') isLockedOpen = false;

  @Input('appNkMatSidenavHelper') id!: string;
  @Input('mat-is-locked-open') matIsLockedOpenBreakpoint!: string;

  constructor(
    private readonly nkMatSidenavService: NkMatSidenavHelperService,
    private readonly matSidenav: MatSidenav
  ) {}

  ngOnInit() {
    this.nkMatSidenavService.setSidenav(this.id, this.matSidenav);

    this.isLockedOpen = false;
    this.matSidenav.mode = 'over';
    this.matSidenav.disableClose = false; // Critical for backdrop to close
    this.matSidenav.close();
  }
}



@Directive({
  selector: '[appNkMatSidenavToggler]'
})
export class NkMatSidenavTogglerDirective {
  @Input('appNkMatSidenavToggler') id!: string;

  constructor(private readonly nkMatSidenavService: NkMatSidenavHelperService) {}

 @HostListener('click')
onClick() {
  const sidenav = this.nkMatSidenavService.getSidenav(this.id);
  const layoutEl = document.querySelector('app-main');

  if (!sidenav || !layoutEl) return;

  const willOpen = !sidenav.opened;
  sidenav.toggle();

  if (willOpen) {
    layoutEl.classList.add('show-quick-panel-backdrop');

    // Optional: remove if it gets closed some other way
    sidenav.closedStart.pipe(take(1)).subscribe(() => {
      layoutEl.classList.remove('show-quick-panel-backdrop');
    });
  } else {
    // Already open, and now toggling to close
    sidenav.closedStart.pipe(take(1)).subscribe(() => {
      layoutEl.classList.remove('show-quick-panel-backdrop');
    });
  }
}

}

